import {} from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import { updateObject } from '../../../../shared/utils';
import * as actionTypes from '../constants/actionTypes';

import { AppAction } from '../../../../store';

import { KeyValuePair } from '../../../../shared/models';
import { UserActivityEvent } from '../../models';

export interface UserActivityEventsState {
  userActivityEvents: UserActivityEvent[] | undefined;
  userActivityEventsError: undefined;
  userActivityEventsLoading: boolean;

  humanReadableEventTypes: KeyValuePair[] | undefined;
  humanReadableEventTypesError: undefined;
  humanReadableEventTypesLoading: boolean;

  userTimeZone: string | undefined;
  userTimeZoneError: undefined;
  userTimeZoneLoading: boolean;
}

const initialState: UserActivityEventsState = {
  userActivityEvents: undefined,
  userActivityEventsError: undefined,
  userActivityEventsLoading: false,

  humanReadableEventTypes: undefined,
  humanReadableEventTypesError: undefined,
  humanReadableEventTypesLoading: false,

  userTimeZone: undefined,
  userTimeZoneError: undefined,
  userTimeZoneLoading: false,
};

const getUserActivityEventsStart = (state: UserActivityEventsState, action: AppAction<any>) => {
  return updateObject(state, {
    userActivityEvents: undefined,
    userActivityEventsError: undefined,
    userActivityEventsLoading: true,
  });
};

const getUserActivityEventsSuccess = (state: UserActivityEventsState, action: AppAction<UserActivityEvent[]>) => {
  return updateObject(state, {
    userActivityEvents: action.data,
    userActivityEventsError: undefined,
    userActivityEventsLoading: false,
  });
};

const getUserActivityEventsFail = (state: UserActivityEventsState, action: AppAction<any>) => {
  return updateObject(state, {
    userActivityEvents: undefined,
    userActivityEventsError: action.error,
    userActivityEventsLoading: false,
  });
};

const getHumanReadableEventTypesStart = (state: UserActivityEventsState, action: AppAction<any>) => {
  return updateObject(state, {
    humanReadableEventTypes: undefined,
    humanReadableEventTypesError: undefined,
    humanReadableEventTypesLoading: true,
  });
};

const getHumanReadableEventTypesSuccess = (state: UserActivityEventsState, action: AppAction<KeyValuePair[]>) => {
  return updateObject(state, {
    humanReadableEventTypes: action.data,
    humanReadableEventTypesError: undefined,
    humanReadableEventTypesLoading: false,
  });
};

const getHumanReadableEventTypesFail = (state: UserActivityEventsState, action: AppAction<any>) => {
  return updateObject(state, {
    humanReadableEventTypes: undefined,
    humanReadableEventTypesError: action.error,
    humanReadableEventTypesLoading: false,
  });
};

const getUserTimeZoneStart = (state: UserActivityEventsState, action: AppAction<any>) => {
  return updateObject(state, {
    userTimeZone: undefined,
    userTimeZoneError: undefined,
    userTimeZoneLoading: true,
  });
};

const getUserTimeZoneSuccess = (state: UserActivityEventsState, action: AppAction<string>) => {
  return updateObject(state, {
    userTimeZone: action.data,
    userTimeZoneError: undefined,
    userTimeZoneLoading: false,
  });
};

const getUserTimeZoneFail = (state: UserActivityEventsState, action: AppAction<any>) => {
  return updateObject(state, {
    userTimeZone: undefined,
    userTimeZoneError: action.error,
    userTimeZoneLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.USER_ACTIVITY_EVENTS_GET_USER_ACTIVITY_EVENTS_START:
      return getUserActivityEventsStart(state, action as AppAction<any>);
    case actionTypes.USER_ACTIVITY_EVENTS_GET_USER_ACTIVITY_EVENTS_SUCCESS:
      return getUserActivityEventsSuccess(state, action as AppAction<UserActivityEvent[]>);
    case actionTypes.USER_ACTIVITY_EVENTS_GET_USER_ACTIVITY_EVENTS_FAIL:
      return getUserActivityEventsFail(state, action as AppAction<any>);

    case actionTypes.USER_ACTIVITY_EVENTS_GET_HUMAN_READABLE_EVENT_TYPES_START:
      return getHumanReadableEventTypesStart(state, action as AppAction<any>);
    case actionTypes.USER_ACTIVITY_EVENTS_GET_HUMAN_READABLE_EVENT_TYPES_SUCCESS:
      return getHumanReadableEventTypesSuccess(state, action as AppAction<KeyValuePair[]>);
    case actionTypes.USER_ACTIVITY_EVENTS_GET_HUMAN_READABLE_EVENT_TYPES_FAIL:
      return getHumanReadableEventTypesFail(state, action as AppAction<any>);

    case actionTypes.USER_ACTIVITY_EVENTS_GET_USER_TIME_ZONE_START:
      return getUserTimeZoneStart(state, action as AppAction<any>);
    case actionTypes.USER_ACTIVITY_EVENTS_GET_USER_TIME_ZONE_SUCCESS:
      return getUserTimeZoneSuccess(state, action as AppAction<string>);
    case actionTypes.USER_ACTIVITY_EVENTS_GET_USER_TIME_ZONE_FAIL:
      return getUserTimeZoneFail(state, action as AppAction<any>);

    default:
      return state;
  }
};

export default reducer;
